//Vercel Api
//  export const Base_Url = "https://jobmongo.webapi.mkisan.com/api";
export const Base_Url = "https://api.pms.technolandsurvey.com/api";
export const GeneratePdf_Url = `https://node-js-multipurpose-api.vercel.app`;
export const GOOGLE_MAPS_API_KEY = "AIzaSyCj4TR9z1v56EBoksTIIFyilc7XKRZcYlM";